import React from 'react'
import {Divider, Paper, Skeleton, SimpleGrid} from "@mantine/core";
import {
    MultipleActivitySkeleton,
    MultipleRegistrationActivitySkeleton
} from "@/components/activity-skeleton/MultipleActivitySkeleton";

export const EmptyActPage = () => {
    return (
        <div className="w-full bg-[#f6f8f9] pb-[200px]">
            <div className="bg-white pt-[60px] pb-[30px]">
                <div className="w-[1280px] mx-auto">
                    <Skeleton height={512} width="100%" mb="lg" radius="xl"/>
                </div>
            </div>

            <div className="border-t border-b border-[#D5DEE2] h-[66px] bg-white">
                <div className="flex justify-between h-full w-[1280px] mx-auto items-center">
                    <div className="flex gap-[30px] h-full items-center">
                        <Skeleton height={20} width={120} radius="xl"/>
                        <Skeleton height={20} width={120} radius="xl"/>
                        <Skeleton height={20} width={120} radius="xl"/>
                        <Skeleton height={20} width={120} radius="xl"/>
                        <Skeleton height={20} width={120} radius="xl"/>
                    </div>
                </div>
            </div>
            <div className="w-[1280px] mx-auto flex justify-between pt-[60px] relative">
                <div className="w-[845px]">
                    <div className="space-y-[20px]">
                        <div className="flex gap-[10px]">
                            <Skeleton height={40} width={120} radius="md"/>
                            <Skeleton height={40} width={120} radius="md"/>
                            <Skeleton height={40} width={120} radius="md"/>
                        </div>


                        <div className="space-y-[15px]">
                            <Skeleton height={26} width={600} radius="md"/>
                            <Skeleton height={20} width={480} radius="md"/>
                        </div>

                        <div className="text-[#8c8c8c] flex gap-[15px] items-center">
                            <div className="flex gap-[4px] items-center">
                                <Skeleton height={20} width={20} circle/>
                                <Skeleton height={20} width={80} radius="md"/>
                            </div>
                            <div className="flex gap-[4px] items-center">
                                <Skeleton height={20} width={20} circle/>
                                <Skeleton height={20} width={80} radius="md"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-[302px]">
                    <div className="sticky top-[166px] space-y-[20px]">
                        <div className="flex p-[24px] flex-col gap-[20px] rounded-[12px] bg-white shadow-md">
                            {/*<div className="text-[16px] font-bold tracking-[0px] text-[#8C8C8C]">活動單位</div>*/}
                            <Skeleton height={16} width={100} radius="md"/>

                            <div className="flex items-center gap-[10px] self-stretch">
                                <Skeleton height={48} width={48} circle />
                                <Skeleton height={20} width={160} radius="md"/>
                            </div>
                            <Skeleton height={40} width="100%" radius="md"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const EmptyActEditorPage = () => {
    return (
        <>
            <div className="flex flex-col gap-6">
                <Skeleton height={486} width={1216} radius="md"/>
                <Divider/>

                <div className="flex gap-3">
                    <Skeleton height={120} width={"50%"} radius="sm"/>
                    <Skeleton height={120} width={"50%"} radius="sm"/>
                </div>
                <Skeleton height={30} width={"100%"} radius="sm"/>
                <Skeleton height={30} width={"100%"} radius="sm"/>
                <Skeleton height={30} width={"80%"} radius="sm"/>
            </div>
        </>
    )
}


export const EmptyActRegisterPage = () => {
    return (

        <div className="w-[1200px] mx-auto pt-[30px] pb-[60px] flex justify-between">
            <div className="flex flex-col w-[800px]">
                <Skeleton height={20} width={"100%"} radius="xl"/>
                <Skeleton height={20} width={"100%"} mt={"lg"} radius="xl"/>
                <Skeleton height={20} width={"90%"} mt={"lg"} radius="xl"/>

                <Skeleton height={80} width={"90%"} mt={60} radius="sm"/>
                <Skeleton height={80} width={"90%"} mt={20} radius="sm"/>
                <Skeleton height={80} width={"90%"} mt={20} radius="sm"/>
                <Skeleton height={80} width={"90%"} mt={20} radius="sm"/>
                <Skeleton height={80} width={"90%"} mt={20} radius="sm"/>
            </div>
            <div className="w-[302px] space-y-[20px]">

                <div className="flex gap-3">
                    <Skeleton height={40} width={80} radius="sm"/>
                    <Skeleton height={40} width={80} radius="sm"/>
                    <Skeleton height={40} width={80} radius="sm"/>
                </div>
                <Skeleton height={20} width={"90%"} mt={20} radius="sm"/>

                <Skeleton height={160} width={"100%"} radius="lg"/>
                <Skeleton height={160} width={"100%"} radius="lg"/>
            </div>
        </div>
    )
}

export const EmptyActivityUnitPage = () => {
    return (


        <div>
            <Skeleton height={20} width={120} radius="xl"/>
            <Skeleton height={20} width={"80%"} mt="sm" radius="xl"/>
            <Skeleton height={20} width={120} mt="sm" radius="xl"/>
            <div className="flex gap-x-6 pt-6">
                <div className="w-[260px] min-w-[260px] max-w-[260px]">
                    <Paper radius="md" withBorder p="lg" bg="var(--mantine-color-body)">
                        <Skeleton height={220} width={"100%"} radius="xl"/>
                        <Skeleton height={20} width={"100%"} mt="lg" radius="xl"/>
                        <Skeleton height={20} width={"100%"} mt="lg" radius="xl"/>
                        <Skeleton height={20} width={"100%"} mt="lg" radius="xl"/>
                        <Skeleton height={20} width={"100%"} mt="lg" radius="xl"/>
                        <Skeleton height={20} width={"100%"} mt="lg" radius="xl"/>
                        <Skeleton height={20} width={"100%"} mt="lg" radius="xl"/>
                        <Skeleton height={20} width={"100%"} mt="lg" radius="xl"/>
                    </Paper>
                </div>

                <div className="space-y-6">
                    <div className="flex gap-3">
                        <Skeleton height={30} width={260} radius="xl"/>
                        <Skeleton height={30} width={260} radius="xl"/>
                        <Skeleton height={30} width={260} radius="xl"/>
                    </div>

                    <div>
                        <SimpleGrid cols={3}>
                            <MultipleActivitySkeleton count={5}/>
                        </SimpleGrid>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const EmptyManagerActivityPage = () => {
    return (
        <div className="flex flex-col gap-5">
            <Skeleton height={80} width={"100%"} radius="sm"/>
            <Skeleton height={80} width={"100%"} radius="sm"/>
            <Skeleton height={80} width={"100%"} radius="sm"/>
            <Skeleton height={80} width={"100%"} radius="sm"/>
            <Skeleton height={80} width={"100%"} radius="sm"/>
        </div>
    )
}


export const EmptyActMediaPage = () => {
    return (

        <div className="w-[1200px] mx-auto pt-[30px] pb-[60px] flex justify-between">
            <div className="flex flex-col w-[800px]">
                <Skeleton height={20} width={"100%"} radius="xl"/>
                <Skeleton height={20} width={"100%"} mt={"lg"} radius="xl"/>
                <Skeleton height={20} width={"90%"} mt={"lg"} radius="xl"/>


                <div className="grid grid-cols-4 mt-10 gap-3">
                    <Skeleton height={160} width={"100%"} radius="sm"/>
                    <Skeleton height={160} width={"100%"} radius="sm"/>
                    <Skeleton height={160} width={"100%"} radius="sm"/>
                    <Skeleton height={160} width={"100%"} radius="sm"/>
                    <Skeleton height={160} width={"100%"} radius="sm"/>
                    <Skeleton height={160} width={"100%"} radius="sm"/>
                </div>
            </div>
            <div className="w-[302px] space-y-[20px]">

                <div className="flex gap-3">
                    <Skeleton height={40} width={80} radius="sm"/>
                    <Skeleton height={40} width={80} radius="sm"/>
                    <Skeleton height={40} width={80} radius="sm"/>
                </div>
                <Skeleton height={20} width={"90%"} mt={20} radius="sm"/>

                <Skeleton height={160} width={"100%"} radius="lg"/>
                <Skeleton height={160} width={"100%"} radius="lg"/>
            </div>
        </div>
    )
}

export const EmptyIndexPage = () => {
    return (

        <div className="w-[1200px] mx-auto">
            <Skeleton height={360} width={"100%"} radius="xl"/>
            <div className="flex gap-5 pt-10">
                <Skeleton height={60} width={"50%"} radius="lg"/>
                <Skeleton height={60} width={"50%"} radius="lg"/>
            </div>

            <div className="pt-10">
                <SimpleGrid cols={3}>
                    <MultipleActivitySkeleton count={5}/>
                </SimpleGrid>
            </div>
        </div>
    )
}
